import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/cases_bg_shadow.png';

const StyledWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 10;
	width: 100%;
	height: 100%;
	transition: opacity 0.3s;
	opacity: 0;
	background: radial-gradient(
			50% 50% at 50% 50%,
			#111314 0%,
			rgba(17, 19, 20, 0) 100%
		),
		rgba(17, 19, 20, 0.98);

	&.overlay-enter {
		opacity: 0;

		.caseItem {
			opacity: 0;
			transform: translateY(200px);
		}
	}

	&.overlay-enter-active,
	&.overlay-enter-done,
	&.overlay-exit {
		opacity: 1;

		.caseItem {
			opacity: 1;
			transform: translateY(0);
		}
	}

	&.overlay-exit-active {
		opacity: 0;

		.caseItem {
			opacity: 0;
			transform: translateY(200px);
		}
	}
`;

const StyledShadow = styled.div`
	position: absolute;
	top: -1050px;
	left: 50%;
	transform: translateX(-50%);
	background-image: url(${shadow});
	background-size: 2100px 2100px;
	background-position: center;
	background-repeat: no-repeat;
	width: 2100px;
	height: 2100px;
	pointer-events: none;
`;

const StyledContainer = styled.div`
	position: absolute;
	top: 140px;
	left: 50%;
	transform: translateX(-50%);
	width: 1240px;
`;

const StyledHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledHeadLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 20px;
		color: #ffffff;
	}
`;

const StyledHeadRight = styled.div`
	display: flex;
	align-items: center;
	gap: 40px;
`;

const StyledCasesContainer = styled.div<{ $delay: number }>`
	display: flex;
	margin-top: 40px;
	transition: gap 0.3s ease ${({ $delay }) => $delay}s;
`;

const StyledListContainer = styled.div<{ $isEntering: boolean }>`
	position: absolute;
	top: 80px;
	right: 0;
	opacity: 0;
	transform: translateX(-500px);
	transition:
		opacity ${({ $isEntering }) => ($isEntering ? '0.5s' : '0.3s')} ease
			${({ $isEntering }) => ($isEntering ? 0.8 : 0)}s,
		transform 0.3s ease ${({ $isEntering }) => ($isEntering ? 0.8 : 0)}s;

	&.list-enter {
		opacity: 0;
		transform: translateX(-400px);
	}

	&.list-enter-active,
	&.list-enter-done,
	&.list-exit {
		opacity: 1;
		transform: translateY(0);
	}

	&.list-exit-active {
		opacity: 0;
		transform: translateX(-400px);
	}
`;

export {
	StyledCasesContainer,
	StyledContainer,
	StyledHead,
	StyledHeadLeft,
	StyledHeadRight,
	StyledListContainer,
	StyledShadow,
	StyledWrapper,
};
